import React, { useState, useMemo, useEffect } from "react";
import { DatePicker, Input, Select, Button, Card, Row, Col, Statistic } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import Table from "../components/Table";
import { useFetchAuditCaseReport } from "../hooks/useFetch";
import { useErrorTopicOptions } from "../../../../hooks/useErrorTopic";
const { RangePicker } = DatePicker;
// import { useFetchCase3 } from "../hooks/useFetch";

const AuditCaseReportPage = () => {
  // หัวข้อเคสผิดพลาด มาจาก master data (admin > Master Data > Error Topic)
  const { options: errorTopicOptions } = useErrorTopicOptions();
  const today = dayjs();
  const companyId = sessionStorage.getItem("activeCompanyId");
  const [selectedDate, setSelectedDate] = useState([today, today]);
  const [selectErrorTopic, setSelectErrorTopic] = useState(null);
  const [userIdSearch, setUserIdSearch] = useState("");
  const { mutateAsync: listAuditCase, isLoading } = useFetchAuditCaseReport();
  const [data, setData] = useState([]);

  const handleClearFilters = () => {
    setSelectedDate([today, today]);
    setSelectErrorTopic(null);
    setUserIdSearch("");
  };

  const handleSearch = () => {
    let startDate = selectedDate[0].format("YYYY-MM-DD");
    let endDate = selectedDate[1].format("YYYY-MM-DD");
    listAuditCase({
      startDate,
      endDate,
      type: selectErrorTopic,
      userId: userIdSearch,
    }).then((res) => {
      setData(res.result);
    }).catch((err) => {
      console.log(err);
    });
  };

  // Function to get remark text from record
  const getRemarkText = (record) => {
    const text = [record.case1Display, record.case2Display, record.case3Display]
      .filter(Boolean)
      .join(" ");
    return text.length > 0 ? text : "-";
  };

  // Group data by remark (only groups with actual remark, not "-")
  const remarkGroups = useMemo(() => {
    const groups = {};
    data.forEach((item) => {
      const remark = getRemarkText(item);
      // Skip if remark is "-" or empty
      if (remark === "-" || !remark || remark.trim() === "") {
        return;
      }
      if (!groups[remark]) {
        groups[remark] = {
          remark,
          count: 0,
          amount: 0,
        };
      }
      groups[remark].count += 1;
      groups[remark].amount += parseFloat(item.auditAmount || 0);
    });
    return Object.values(groups).sort((a, b) => b.count - a.count);
  }, [data]);
  return (
    <div style={{ padding: 16, background: "#f5f5f5", minHeight: "100vh", marginLeft: 16 }}>
      {/* Title */}
      <div style={{ marginBottom: 20 }}>
        <h1
          style={{
            margin: 0,
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#212121",
            letterSpacing: "0.5px",
            lineHeight: 1.2,
          }}
        >
          รายงานการตรวจสอบเคส
        </h1>
      </div>

      {/* Summary Section */}
      {/* <div
        style={{
          display: "flex",
          gap: 20,
          marginBottom: 20,
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 30,
            background: "#fff",
            borderRadius: 10,
            padding: "16px 24px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <div>
            <div style={{ fontSize: 14, color: "#666", marginBottom: 4 }}>
              เคสทั้งหมด :
            </div>
            <div style={{ fontSize: 28, fontWeight: "bold", color: "#212121" }}>
              {data?.length || 0}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 14, color: "#666", marginBottom: 4 }}>
              ยอดรวม :
            </div>
            <div style={{ fontSize: 28, fontWeight: "bold", color: "#212121" }}>
              {data?.reduce((sum, item) => sum + (parseInt(item.amount) || 0), 0) || 0}
            </div>
          </div>
        </div>

      </div> */}


      {/* Filter Section */}
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: 20,
          marginBottom: 20,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            gap: 16,
            alignItems: "end",
          }}
        >
          {/* Date Range Picker */}
          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              วันที่
            </label>
            <RangePicker
              value={selectedDate}
              onChange={setSelectedDate}
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              allowClear={false}
            />
          </div>

          {/* Error Topic Select */}
          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              Error Topic
            </label>
            <Select
              value={selectErrorTopic}
              onChange={setSelectErrorTopic}
              allowClear
              options={errorTopicOptions}
              style={{ width: "100%" }}
            />
          </div>

          {/* User ID Select */}
          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",  
              }}
            >
              User ID
            </label>
            <Input
              value={userIdSearch}
              onChange={(e) => setUserIdSearch(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: 8 }}>
            <Button type="primary" onClick={handleSearch}>
              ค้นหา
            </Button>
            <Button onClick={handleClearFilters}>
              ล้างค่า
            </Button>
          </div>
        </div>
      </div>


      {/* Table Section */}
      <Table
        data={data}
        loading={isLoading}
        refetch={handleSearch}
      />

      {/* Dashboard Section - Grouped by Remark */}
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: 20,
          marginTop: 20,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* <Row gutter={[16, 16]}>
          {remarkGroups.map((group, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <Card
                style={{
                  borderRadius: 8,
                  border: "1px solid #d9d9d9",
                }}
              >
                <Statistic
                  title={
                    <div
                      style={{
                        fontSize: 16,
                        color: "#666",
                        marginBottom: 8,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={group.remark}
                    >
                      {group.remark || "-"}
                    </div>
                  }
                  value={group.count}
                  suffix="รายการ"
                  valueStyle={{ color: "#1890ff", fontSize: 20 }}
                />
                <div
                  style={{
                    marginTop: 8,
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#52c41a",
                  }}
                >
                  ยอดรวม: {group.amount.toLocaleString("th-TH")}
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        {remarkGroups.length === 0 && (
          <div
            style={{
              textAlign: "center",
              padding: 40,
              color: "#999",
            }}
          >
            ไม่มีข้อมูล
          </div>
        )} */}
      </div>
    </div>
  );
};

export default AuditCaseReportPage;

